/**
 * Loads the template and return function for obtaining copy of template each time it is called.
 */
export async function loadTemplate(templateName: string): Promise<() => string>
{
	const response = await fetch(templateName);
	const template = await response.text();

	return () => template;
}
